const apiGatewayUrl = process.env.VUE_APP_API_GATEWAY_URL;

const constants = {
  Cookies: {
    LanguagePreference: 'lang_pref',
  },
  UrlParameters: {
    LanguagePreference: 'lang',
  },
  UrlEndings: {
    NrsHome: '/nrs/home/',
    NrsLogin: '/nrs-login/account-login',
    MyNrsEmailPreferences: '/mynrs/preferences/email',
    DataProcessingAddendum: 'dpa.pdf',
  },
  Languages: {
    English: 'en-us',
    Chinese: 'zh-cn',
    Japanese: 'ja',
  },
  Api: {
    Unsubscribe: `${apiGatewayUrl}/v1/nrsservice/user/umpUnsubscribeFromPage`,
    GetUmpUser: `${apiGatewayUrl}/v1/nrsservice/user/UmpUser/{userGuid}`,
  },
};

export default constants;
